import { useAxiosCreate } from '@/backend/utils.js'
import authHeader from '@/backend/auth/auth-header'


const api = useAxiosCreate('api')

export async function getBaseRates(params = {}) {
  const response = await api.get('memory/base-rates', {
    params,
    headers: authHeader(),
  })
  return response.data
}

export async function createBaseRate(payload) {
  const response = await api.post('memory/base-rates', payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function lookupBaseRate({ from_city, to_city }) {
  const response = await api.get('memory/base-rates/lookup', {
    params: { from_city, to_city },
    headers: authHeader(),
  })
  return response.data
}

export async function updateBaseRate(id, payload) {
  const response = await api.put(`memory/base-rates/${id}`, payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function deleteBaseRate(id) {
  const response = await api.delete(`memory/base-rates/${id}`, {
    headers: authHeader(),
  })
  return response.data
}

export async function exportBaseRates(params = {}) {
  return api.get('memory/base-rates/export', {
    params,
    headers: authHeader(),
    responseType: 'blob',
    validateStatus: () => true,
  })
}

export async function importBaseRates(file) {
  const formData = new FormData()
  formData.append('file', file)
  const response = await api.post('memory/base-rates/import', formData, {
    headers: authHeader(),
  })
  return response.data
}
